<template>
    <div class="zhuanshudingding">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box-cont1">
                <p class="title-box">企业数字化办公运营面临的挑战</p>
                <p class="con-box">如何既能快速打造数字化办公运营平台满足业务发展需要，又能保障信息安全及业务生态之间的完美融合</p>
                <ul class="ul-box">
                    <li>
                        <img src="./img-info/img-info-img-s1.jpg" alt="">
                        <p class="pp1">自有平台难以建设</p>
                        <p class="pp2">企业如何快速打造专属、高效、安全、稳定、</p>
                        <p class="pp2">开放的数字化办公运营平台</p>
                    </li>
                    <li>
                        <img src="./img-info/img-info-img-s2.jpg" alt="">
                        <p class="pp1">信息安全难以保障</p>
                        <p class="pp2">企业上云及协同办公中如何保障全链路的基础</p>
                        <p class="pp2">安全、业务安全和数据安全</p>
                    </li>
                    <li>
                        <img src="./img-info/img-info-img-s3.jpg" alt="">
                        <p class="pp1">多业务系统难以融合</p>
                        <p class="pp2">企业如何建立信息化顶层设计，打破“信息孤</p>
                        <p class="pp2">岛”和“数据烟囱”</p>
                    </li>
                </ul>
            </div>
            <div class="box2-cont1">
                <p class="miderTitle">解决方案优势</p>
                <div class="line"></div>
                <p class="letter-title">让固定资产管理高效、可控，充分发挥资产的作用，降低企业运营成本。</p>
                <ul class="box2-ul">
                    <li>
                        <p class="ps1">定制自有APP</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">企业自由设计界面的布局和样式</p>
                        <p class="ps2">轻松实现千人千面</p>
                    </li>
                    <li>
                        <p class="ps1">全方位的安全服务</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">全链接的数据加密、信息安全管控</p>
                        <p class="ps2">专属空间实现业务与数据的分离</p>
                    </li>
                    <li>
                        <p class="ps1">业务融合</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">提供100+专属API融合</p>
                        <p class="ps2">各业务系统，全面提升业务协同效率</p>
                    </li>
                </ul>
                
            </div>
        </div>
        <div class="cont2">
            <p class="miderTitles">推荐功能</p>
            <ul class="tuijian">
                <li>
                    <div class="left">
                        <img src="https://img.alicdn.com/tfs/TB12vaGgOcKOu4jSZKbXXc19XXa-120-120.png" alt="">
                    </div>
                    <div class="right">
                        <p class="right-title">专属设计</p>
                        <p class="right-info">企业可自主设置APP的logo、名称、登录页、启动页、皮肤、工作台、菜单、底部工具栏等截面</p>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <img src="https://img.alicdn.com/tfs/TB1roRHLAL0gK0jSZFAXXcA9pXa-120-120.png" alt="">
                    </div>
                    <div class="right">
                        <p class="right-title">专属APP</p>
                        <p class="right-info">全面定制独立APP，自主设置APP的Logo和名称，独立打包支持Windows、Mac、IOS、Android等多端统一体验</p>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <img src="https://img.alicdn.com/tfs/TB1VBdYLrj1gK0jSZFuXXcrHpXa-120-120.png" alt="">
                    </div>
                    <div class="right">
                        <p class="right-title">miniOSS</p>
                        <p class="right-info">基于混合云的存储阵列，可部署在客户机房，数据归属客户，安全稳定，部署敏捷，性价比高，支持钉钉文件直存</p>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <img src="https://img.alicdn.com/tfs/TB17S4SLBr0gK0jSZFnXXbRRXXa-120-120.png" alt="">
                    </div>
                    <div class="right">
                        <p class="right-title">专属安全</p>
                        <p class="right-info">解决了企业上云协同办公过程存在的基础安全、业务安全及数据安全的安全顾虑，提升业务数据保护能力</p>
                    </div>
                </li>
            </ul>
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="sssdd"></div>
        </div>
    </div>
</template>
        
<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       }
   }
}
</script>
<style lang='less' scoped>
.zhuanshudingding{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/jjfa_zsdd_1920337.5@1x-tuya.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .cont1{
        width: 100%;
        .box-cont1{
            width: 80%;
            margin: 40px auto;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
            border-radius: 6px;
            padding: 40px 90px;
            .title-box{
                font-size: 30px;
                color: #000;
                line-height: 40px;
                letter-spacing: 2px;
            }
            .con-box{
                font-size: 22px;
                line-height: 25px;
                color:#696969;
                margin-top: 35px;
                letter-spacing: 2px;
            }
            .ul-box{
                width: 100%;
                margin-top: 43px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 30%;
                    text-align: center;
                    img{
                        width: 100%;
                        height: 250px;
                    }
                    .pp1{
                        font-size:24px;
                        color:#000000;
                        text-align: center;
                        line-height: 45px;
                        font-weight: bold;
                        letter-spacing: 2px;
                        margin-top: 10px;
                    }
                    .pp2{
                        font-size:18px;
                        color:#808080;
                        text-align: center;
                        line-height: 30px;
                    }
                }
            }
        }
        .box2-cont1{
            width: 100%;
            .box2-ul{
                width: 80%;
                margin: 50px auto;
                display: flex;
                justify-content: space-between;
                li{
                    width: 30%;
                    padding: 50px;
                    background-image: url("https://img.alicdn.com/tfs/TB15Q3KDhD1gK0jSZFKXXcJrVXa-370-184.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    padding-top: 35px;
                    .ps1{
                        font-size: 25px;
                        font-weight: 100;
                        color: #fff;
                        text-align: center;
                        line-height: 40px;
                    }
                    .lin-yuanjiao{
                        width: 50px;
                        height: 3px;
                        border-radius: 6px;
                        background-color: #fff;
                        margin: 0 auto;
                        margin-bottom: 22px;
                        margin-top: 13px;
                    }
                    .ps2{
                        font-size: 20px;
                        color:#FFFFFF;
                        line-height: 28px;
                        text-align: center;
                        letter-spacing: 1px;
                        margin-top: 8px;
                    }
                }
            }
        }
        
    }
    .cont2{
        width: 100%;
        background-color: #F7F7F7;
        .miderTitles{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 130px;
        }
        .tuijian{
            width: 80%;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li{
                width: 45%;
                background-color: #fff;
                transition: all 0.2s linear;
                margin-bottom: 40px;
                padding-bottom: 40px;
                display: flex;
                .left{
                    width: 200px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 75px;
                        height: 75px;
                    }
                }
                .right{
                    flex: 1;
                    padding-right: 30px;
                    .right-title{
                        margin-top: 59px;
                        font-size: 28px;
                        color: #252525;
                        font-weight: 100;
                    }
                        
                    .right-info{
                        font-size: 19px;
                        margin-top: 15px;
                        color: #7A7A7A;
                        font-weight: 100;
                        line-height: 30px;
                    }
                }
            }
            li:hover{
                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            }
        }
        .zhuanjia{
            width: 80%;
            background-color: #fff;
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 62px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
        .sssdd{
            height: 40px;
        }
    }
}
.miderTitle{
    font-size: 35px;
    text-align: center;
    color: #000;
    line-height: 50px;
}
.line{
   width: 40px;
    height: 2px;
    background-color: rgba(0, 137, 255, 1);
    margin: 0 auto;
    margin-top: 12px;
 }
 .letter-title{
    font-size: 21px;
    text-align: center;
   color: #000;
    line-height: 30px;
     margin-top: 15px;
}
</style>